import { useEffect, useRef, useState } from 'react';

export default function useReveal(threshold = 0.12, rootMargin = '0px') {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { setVisible(true); return; }
    const io = new IntersectionObserver(
      ([entry]) => { setVisible(entry.isIntersecting); },
      { threshold, rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold, rootMargin]);

  return [ref, visible];
}
